<div class="form-container sign-up-container">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
  <form *ngIf='!isLoading && passwordSession' (submit)='onUpdatePassword(changePasswordForm)' #changePasswordForm="ngForm">
    <nb-card>
      <nb-card-body fxLayout="column">
        <span>
          <img src="../../../assets/logo2.png" alt="" srcset="" style="width: 112px;height: 112px;">
        </span>
        <h3>Change Password</h3>
        <mat-form-field appearance="outline">
          <mat-label>New Password</mat-label>
          <input type="password" name="password1" minlength="6" ngModel matInput placeholder="password" #passwordInput1="ngModel" required>
          <mat-error *ngIf="passwordInput1.invalid">"please enter valid password"</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Re-Enter New Password</mat-label>
          <input type="password" name="password2" minlength="6" ngModel matInput placeholder="password" #passwordInput2="ngModel" required>
          <mat-error *ngIf="passwordInput2.invalid">"please enter valid password and both should be same"</mat-error>
        </mat-form-field>
        <button type="submit">Update Password</button>
      </nb-card-body>
    </nb-card>
  </form>
  <form *ngIf='!isLoading && verificationSession' (submit)='onVerifyAccount()' #verifyAccountForm="ngForm">
    <nb-card>
      <nb-card-body fxLayout="column">
        <span>
          <img src="../../../assets/logo2.png" alt="" srcset="" style="width: 112px;height: 112px;">
        </span>
        <h3>Verify Account</h3>
        <span>Click on the button below to activate your account.</span>
        <button type="submit">Verify Account</button>
        <!-- <a href="/login">go to Login page</a> -->
      </nb-card-body>
    </nb-card>
  </form>
</div>
